import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteBlogCategory } from "../../api/apiBlogCategories";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف تصنيف (soft delete)
 */
export function useDeleteBlogCategory() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteBlogCategoryMutate,
        isPending,
    } = useMutation({
        mutationFn: deleteBlogCategory,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["blog-categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete blog category");
        },
    });

    return {
        deleteBlogCategoryMutate,
        isPending,
    };
}
